import { render, staticRenderFns } from "./AssetReviewComment.vue?vue&type=template&id=792fd9ab"
import script from "./AssetReviewComment.vue?vue&type=script&lang=js"
export * from "./AssetReviewComment.vue?vue&type=script&lang=js"
import style0 from "./AssetReviewComment.vue?vue&type=style&index=0&id=792fd9ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports